<div class="profile" *ngIf="user">
	<div class="avatar">{{ initials }}</div>
	<span class="name">{{ user.name }}</span>
</div>
